<h2 mat-dialog-title>{{ data?.title || "Are you sure?" }}</h2>
<mat-dialog-content>
  <div [innerHTML]="data?.message"></div>
</mat-dialog-content>
<mat-dialog-actions class="actions">
  @if (!data.hideCancel) {
    <button mat-stroked-button type="button" mat-dialog-close>
      {{ data?.cancelLabel || "Cancel" }}
    </button>
  }
  <button mat-button type="button" [mat-dialog-close]="true">
    {{ data?.confirmLabel || "Confirm" }}
  </button>

</mat-dialog-actions>
